import { useContext, useMemo } from 'react';
import { FormattedNumber } from 'react-intl';

import { NumberFormatOptions } from '@formatjs/ecma402-abstract';

import { PortfolioPrivacyContext } from './PortfolioPrivacyContext';
import { PrivacyContextAwareProps } from './PrivacyContextAwareProps';

export interface PrivacyContextAwareNumberProps extends PrivacyContextAwareProps, NumberFormatOptions {}

export const PrivacyContextAwareNumber = ({ length, value, ...rest }: PrivacyContextAwareNumberProps) => {
  const { isPrivacyModeEnabled } = useContext(PortfolioPrivacyContext);

  const hiddenDisplay = useMemo(() => '*'.repeat(length), [length]);

  return isPrivacyModeEnabled ? <>{hiddenDisplay}</> : <FormattedNumber {...rest} value={value} />;
};
